import React from 'react';

/**
 * <PhoneFrame /> — mobile preview shell. Scales down to fit its column
 * (max-width 100%, fixed 1:2 aspect ratio) so several frames wrap on tablets.
 * Purely decorative chrome: no fake clock or signal icons.
 */
const PhoneFrame = ({ title, bg = 'var(--cw-surface-alt)', width = 280, children }) => (
  <figure style={{ width, maxWidth: '100%', margin: 0 }}>
    <div style={{ background: 'var(--cw-navy)', borderRadius: 34, padding: 10, boxShadow: '0 20px 45px rgba(15,23,42,0.22)' }}>
      <div style={{ background: bg, borderRadius: 26, overflow: 'hidden', aspectRatio: '1 / 2', position: 'relative' }}>
        <div aria-hidden="true" style={{ height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ width: 72, height: 6, borderRadius: 3, background: 'var(--cw-border-strong)' }} />
        </div>
        <div className="cw-scroll" style={{ height: 'calc(100% - 28px)', overflowY: 'auto' }}>{children}</div>
      </div>
    </div>
    {title && <figcaption style={{ textAlign: 'center', fontSize: 'var(--cs-text-sm)', fontWeight: 600, color: 'var(--cw-text-2)', marginTop: 10 }}>{title}</figcaption>}
  </figure>
);

export default PhoneFrame;
